class LayoutSwitch extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('button');
        this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
        this.addListeners();
    }

    disconnectedCallback() {
        this.removeListeners();
    }

    addListeners() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', this.handleClick);
        });
    }

    removeListeners() {
        this.buttons.forEach((button) => {
            button.removeEventListener('click', this.handleClick);
        });
    }

    /**
     * @param {Event} event - The event.
     */
    onClick(event) {
        const button = event.currentTarget;

        if (!(button instanceof HTMLButtonElement)) return;

        const { switchItem, type } = button.dataset;

        if (!switchItem || !type) return;

        requestIdleCallback(() => {
            this.saveValueToStorage(type, switchItem);
            this.applyStyleToGrid(type, switchItem);
        });
    }

    /**
     * @param {string} type
     * @param {string} valueStyle
     */
    applyStyleToGrid(type, valueStyle) {
        const typeProperty = `--item-per-col-${type}-html`;
        document.documentElement.style.setProperty(typeProperty, valueStyle);
    }

    /**
     * @param {string} type
     * @param {string} value
     */
    saveValueToStorage(type, value) {
        sessionStorage.setItem(`layout-switch-item-${type}`, value);
    }
}

if (!customElements.get('layout-switch')) {
    customElements.define('layout-switch', LayoutSwitch);
}
